import { createRootRouteWithContext, createRoute, createRouter } from "@tanstack/react-router";
import { App } from "./App";
import { Error404 } from "./pages/404";
import { Error } from "./pages/Error";
import { Index } from "./pages/Index";
import { Nodes } from "./pages/nodes/Nodes";
import { NodesOverview } from "./pages/nodes/NodesOverview";
import { Scanners } from "./pages/scanners/Scanners";
import { ScannersOverview } from "./pages/scanners/ScannersOverview";
import { Timelapses } from "./pages/timelapses/Timelapses";
import { TimelapsesOverview } from "./pages/timelapses/TimelapsesOverview";
import { TimelapsesDetail } from "./pages/timelapses/TimelapsesDetail";
import { Home } from "./pages/Home";
import { Logs } from "./pages/logs/Logs";

const root = createRootRouteWithContext()({
  component: App,
});

const index = createRoute({
  getParentRoute: () => root,
  id: "public-layout",
  component: Index,
});

const home = createRoute({
  getParentRoute: () => index,
  path: "/",
  component: Home,
})

//
// Nodes
//

const nodes = createRoute({
  getParentRoute: () => index,
  path: "/nodes",
  component: Nodes,
});

const nodeOverview = createRoute({
  getParentRoute: () => nodes,
  path: "/",
  component: NodesOverview,
});

//
// Scanners
//

const scanners = createRoute({
  getParentRoute: () => index,
  path: "/scanners",
  component: Scanners,
});

const scannersOverview = createRoute({
  getParentRoute: () => scanners,
  path: "/",
  component: ScannersOverview,
});

//
// Timelapses
//

const timelapses = createRoute({
  getParentRoute: () => index,
  path: "/timelapses",
  component: Timelapses,
});

const timelapsesOverview = createRoute({
  getParentRoute: () => timelapses,
  path: "/",
  component: TimelapsesOverview,
});

const timelapsesDetail = createRoute({
  getParentRoute: () => timelapses,
  path: "/$id",
  component: TimelapsesDetail,
})

//
// Logs
//

const logs = createRoute({
  getParentRoute: () => index,
  path: "/logs",
  component: Logs,
})

const routeTree = root.addChildren([
  index.addChildren([
    home,
    nodes.addChildren([
      nodeOverview,
    ]),
    scanners.addChildren([
      scannersOverview,
    ]),
    timelapses.addChildren([
      timelapsesOverview,
      timelapsesDetail
    ]),
    logs,
  ]),
]);

export const router = createRouter({
  routeTree,
  defaultPreload: "render",
  defaultPreloadStaleTime: 0, // Data is immediatly marked as stale and will refetch when the user navigates to the page
  scrollRestoration: true,
  defaultErrorComponent: Error,
  defaultNotFoundComponent: Error404,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
